<template>
  <div>
    <Title>简易项目综合评审表</Title>
    <div class="panel">
      <div class="label">项目名称</div>
      <div class="value3">{{ extra.projectName }}</div>

      <div class="label">项目编号</div>
      <div class="value1">{{ extra.projectCode }}</div>
      <div class="label">设计编号</div>
      <div class="value2">{{ extra.designCode }}</div>

      <div class="label">管理级别</div>
      <div class="value1">
        <DataDictFinder dictType="cosys.manageLevel" :dictValue="extra.manageLevel" />
      </div>
      <div class="label">阶段</div>
      <div class="value2">
        <DataDictFinder dictType="cosys.designPhase" :dictValue="extra.phaseCode" />
      </div>

      <div class="label">版本</div>
      <div class="value1">{{ extra.planVersion }}</div>
      <div class="label">项目负责人</div>
      <div class="value2">{{ extra.prjLeaderName }}</div>

      <div class="label">项目分管总工</div>
      <div class="value1">{{ extra.chiefEngineerName }}</div>
      <div class="label">部门分管负责人</div>
      <div class="value2">{{ extra.deptLeaderName }}</div>


      <div class="label">设计评审日期</div>
      <div class="value1">{{ extra.designReviewDate | date }}</div>
      <div class="label">设计输入日期</div>
      <div class="value2">{{ extra.designInputDate | date }}</div>

      <div class="label">出图日期</div>
      <div class="value1">{{ extra.drawingDate | date }}</div>
      <div class="label">要求完成日期</div>
      <div class="value2">{{ extra.requireFinishDate | date }}</div>

      <div class="label">归档时间</div>
      <div class="value1">{{ extra.archiveDate | date }}</div>
      <div class="label">评审主持人</div>
      <div class="value2">{{ extra.reviewHostName }}</div>

      <div class="label">项目类别</div>
      <div class="value3">
        <DataDictFinder dictType="cosys.prjCategory" :dictValue="extra.prjCategory" />
      </div>

      <div class="label full-label">设计输入要求</div>
      <div class="value4">{{ extra.designInputReq }}</div>

      <div class="label full-label">评审意见</div>
      <div class="value4">{{ extra.reviewOpinion }}</div>

      <div class="label full-label">备注</div>
      <div class="value4">{{ extra.remark }}</div>

      <div class="label">附件</div>
      <div class="value3">
        <template v-if="extra.attachment">
          <div v-for="(item, index) in attachmentList" :key="index">
            <a :href="item.url" target="_blank" @click.prevent="handleFileClick($event, item.url, item.name)">{{ item.name }}</a>
          </div>
        </template>
      </div>
    </div>

    <Title>专业信息</Title>
    <div>
      <a-table
          :columns="majorColumns"
          :data-source="extra.majorsDetail || []"
          row-key="sortNo"
          :pagination="false"
          bordered
      />
    </div>

    <Title>子项信息</Title>
    <div>
      <a-table
          :columns="subItemColumns"
          :data-source="extra.subItems || []"
          row-key="sortNo"
          :pagination="false"
          bordered
      />
    </div>

    <Title>子项专业人员信息</Title>
    <div>
      <a-table
          :columns="subMajorColumns"
          :data-source="extra.subMajors || []"
          row-key="sortNo"
          :pagination="false"
          bordered
      />
    </div>

    <Padding />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Title from "../Title";
export default {
  components: {
    Title,
  },
  computed: {
    ...mapState("approval", ["detail"]),
    ...mapGetters("setting", ["findDataDict"]),
    extra() {
      return this.detail.extra ? this.detail.extra : {};
    },
    majorColumns() {
      const majorDict = this.findDataDict("cosys.major") || [];
      return [
        { title: "专业名称", dataIndex: "majorName", key: "majorName", width: 100, customRender: (text, record) => { if (text) return text; if (record.majorCode) { const item = majorDict.find(d => d.value === record.majorCode); return item ? item.name : record.majorCode; } return '-'; } },
        { title: "专业编号", dataIndex: "majorCode", key: "majorCode", width: 120, customRender: (text) => text || '-' },
        { title: "专业负责人", dataIndex: "majorLeaderNames", key: "majorLeaderNames", width: 150, customRender: (text) => text || '-' },
        { title: "设计人", dataIndex: "designerNames", key: "designerNames", width: 120, customRender: (text) => text || '-' },
        { title: "复核人", dataIndex: "reviewerNames", key: "reviewerNames", width: 120, customRender: (text) => text || '-' },
        { title: "审核人", dataIndex: "auditorNames", key: "auditorNames", width: 120, customRender: (text) => text || '-' },
        { title: "审定人", dataIndex: "approverNames", key: "approverNames", width: 120, customRender: (text) => text || '-' },
        { title: "备注", dataIndex: "remark", key: "remark", width: 120, customRender: (text) => text || '-' },
      ];
    },
    subMajorColumns() {
      const majorDict = this.findDataDict("cosys.major") || [];
      return [
        { title: "子项名称", dataIndex: "subName", key: "subName", width: 120, customRender: (text) => text || '-' },
        { title: "子项编号", dataIndex: "subCode", key: "subCode", width: 120, customRender: (text) => text || '-' },
        { title: "专业名称", dataIndex: "majorName", key: "majorName", width: 100, customRender: (text, record) => { if (text) return text; if (record.majorCode) { const item = majorDict.find(d => d.value === record.majorCode); return item ? item.name : record.majorCode; } return '-'; } },
        { title: "专业编号", dataIndex: "majorCode", key: "majorCode", width: 100, customRender: (text) => text || '-' },
        { title: "设计人", dataIndex: "designerNames", key: "designerNames", width: 120, customRender: (text) => text || '-' },
        { title: "复核人", dataIndex: "reviewerNames", key: "reviewerNames", width: 120, customRender: (text) => text || '-' },
        { title: "审核人", dataIndex: "auditorNames", key: "auditorNames", width: 120, customRender: (text) => text || '-' },
        { title: "审定人", dataIndex: "approverNames", key: "approverNames", width: 120, customRender: (text) => text || '-' },
      ];
    },
    subItemColumns() {
      const majorDict = this.findDataDict("cosys.major") || [];
      return [
        { title: "子项编号", dataIndex: "subCode", key: "subCode", width: 120, customRender: (text) => text || '-' },
        { title: "子项名称", dataIndex: "subName", key: "subName", width: 160, customRender: (text) => text || '-' },
        { title: "参与专业", dataIndex: "majors", key: "majors", width: 200, customRender: (codes) => { if (!codes) return '-'; return codes.split(',').map(c => { const item = majorDict.find(d => d.value === c); return item ? item.name : c; }).join(', '); } },
        { title: "子项负责人", dataIndex: "subLeaderName", key: "subLeaderName", width: 120, customRender: (text) => text || '-' },
        { title: "计划结束日期", dataIndex: "planEndDate", key: "planEndDate", width: 120, customRender: (text) => text ? new Date(text).toLocaleDateString() : '-' },
        { title: "排序", dataIndex: "sortNo", key: "sortNo", width: 80, customRender: (text) => text || '-' },
        { title: "备注", dataIndex: "remark", key: "remark", width: 120, customRender: (text) => text || '-' },
      ];
    },
    attachmentList() {
      if (!this.extra.attachment) return [];
      return this.extra.attachment.split(",").filter(Boolean).map(url => {
        let name;
        try {
          name = decodeURIComponent(this.$getFileName(url));
        } catch (e) {
          name = this.$getFileName(url);
        }
        return { url, name };
      });
    },
  },
  methods: {
    isPdfFile(filename) {
      return filename && filename.toLowerCase().endsWith('.pdf');
    },
    previewPdf(url, filename) {
      const routeUrl = this.$router.resolve({
        path: '/pdf-preview',
        query: { url, title: filename || 'PDF预览' }
      }).href;
      window.open(routeUrl, '_blank');
    },
    deepDecodeURIComponent(str) {
      // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
      // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
      // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
      let decoded = str;
      while (decoded.includes('%25')) {
        const prev = decoded;
        try {
          decoded = decodeURIComponent(decoded);
        } catch (e) {
          break;
        }
        if (decoded === prev) break;
      }
      return decoded;
    },
    handleFileClick(event, url, filename) {
      event.preventDefault();
      const decodedUrl = this.deepDecodeURIComponent(url);
      if (this.isPdfFile(filename)) {
        this.previewPdf(decodedUrl, filename);
      } else {
        const a = document.createElement('a');
        a.href = decodedUrl;
        a.download = filename || '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
  },
  filters: {
    date(val) {
      if (!val) return '-';
      return new Date(val).toLocaleDateString();
    },
  },
};
</script>

<style lang="less" scoped>
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .full-label {
    grid-column-start: 1;
    grid-column-end: 2;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value4 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>
